import { User } from '@/models/user'
import { BaseAPI } from '@/api/base.api'
import { VUE_APP_SIT_API_URL } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import Documento from '@/models/documento';

export class DocumentoAPI extends BaseAPI<Documento> {

  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}/autorizacoesFretamento/documentos`;
  }
  public getAll (): AxiosObservable<Documento[]> {
    return this.axios.post(`${this.apiUrl}`, { })
  }
}
